import { withStyles } from '@material-ui/core/styles';
import Preloader from './Preloader';
import styles from './Preloader.styles';

export default withStyles(styles)(Preloader);
